import type { PartSvgProps } from './types'

export default function AkHandguardUpperSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 200,
  height = 60
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 200 60" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="8" width="192" height="44" rx="6"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      <line x1="20" y1="20" x2="180" y2="20"
            stroke={stroke} strokeWidth="1" strokeOpacity="0.5" />
      <line x1="20" y1="30" x2="180" y2="30"
            stroke={stroke} strokeWidth="1" strokeOpacity="0.5" />
      <line x1="20" y1="40" x2="180" y2="40"
            stroke={stroke} strokeWidth="1" strokeOpacity="0.5" />
    </svg>
  )
}
